import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { SITE } from "@/data/site";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { href: "#services", label: "Služby" },
    { href: "#pricing", label: "Cena" },
    { href: "#reviews", label: "Recenze" },
    { href: "#faq", label: "FAQ" },
    { href: "#locations", label: "Pobočky" },
  ];

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-b border-brand-border" : "bg-transparent"
      }`}
    >
      <nav className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 lg:h-20 flex items-center justify-between">
        <a href="/" data-testid="brand-logo" className="flex items-center gap-2 group">
          <span className="inline-block w-2 h-2 bg-brand-accent rounded-full dot-pulse" />
          <span className="font-display font-black text-xl tracking-tight uppercase">
            {SITE.brand}
          </span>
        </a>

        <ul className="hidden lg:flex items-center gap-10 text-sm text-brand-muted">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="hover:text-white transition-colors duration-200"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden lg:flex items-center gap-3">
          <a href="/muj-ucet" data-testid="nav-account-link" className="text-sm text-brand-muted hover:text-white transition-colors">Můj účet</a>
          <a
            href="#reservation"
            data-testid="nav-book-button"
            className="group inline-flex items-center gap-2 bg-brand-accent text-black font-semibold px-5 py-2.5 hover:bg-brand-accentHover transition-all"
          >
            Rezervovat termín
            <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden p-2 text-white"
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-brand-border"
        >
          <ul className="px-6 py-6 space-y-4">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="block text-lg text-white hover:text-brand-accent"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#reservation"
                onClick={() => setOpen(false)}
                data-testid="nav-book-button-mobile"
                className="inline-block bg-brand-accent text-black font-semibold px-5 py-2.5"
              >
                Rezervovat termín →
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
